export default __webpack_public_path__ + "static/media/unbox-arena.fd74748b.gif";